/**
 * Modular What's New entries for the "widgets" module: insight home-screen widgets. `routes` use the real navigation screen names from AppNavigator.jsx.
 *
 * @type {Object[]}
 */
const widgetsEntries = [
  {
    id: 'widgets-insight-41-2026-10',
    module: 'widgets',
    routes: ['WidgetsScreen', 'InsightWidgetSettingsScreen'],
    date: '2026-10-17',
    version: '4.15.1',
    global: true,
    type: 'feature',
    title: {
      en: "📲 41 new home-screen widgets",
      hu: "📲 41 új kezdőképernyős widget",
      de: "📲 41 neue Homescreen-Widgets",
      cn: "📲 41 个新的主屏幕小组件",
      ro: "📲 41 de widgeturi noi pentru ecranul principal",
      svn: "📲 41 novih pripomočkov za začetni zaslon",
    },
    body: {
      en: "Your key numbers no longer need an app launch: 41 new insight widgets show finance and P&L, HR, fleet, stock, sales and leads, support, work orders, Viva, and SMS and e-mail statistics right on the home screen, on Android and iPhone. Pick them in Widgets, and set how often they reload on their own.",
      hu: "A fontos számaid megnézéséhez már nem kell megnyitni az appot: 41 új összesítő widget mutatja a pénzügyet és az eredményt, a HR-t, a flottát, a készletet, az értékesítést és a leadeket, az ügyfélszolgálatot, a munkalapokat, a Vivát, valamint az SMS- és e-mail-statisztikát a kezdőképernyőn, Androidon és iPhone-on is. A Widgetek menüben választhatod ki őket, és beállíthatod, milyen gyakran frissüljenek maguktól.",
      de: "Für Ihre wichtigsten Zahlen müssen Sie die App nicht mehr öffnen: 41 neue Insight-Widgets zeigen Finanzen und GuV, Personal, Fuhrpark, Lager, Vertrieb und Leads, Support, Arbeitsaufträge, Viva sowie SMS- und E-Mail-Statistiken direkt auf dem Homescreen – auf Android und iPhone. Wählen Sie sie unter Widgets aus und legen Sie fest, wie oft sie sich selbst aktualisieren.",
      cn: "查看关键数据不必再打开应用：41 个新的洞察小组件直接在主屏幕上显示财务与损益、人事、车队、库存、销售与线索、客服、工单、Viva 以及短信和邮件统计，Android 和 iPhone 均支持。在“小组件”中选择它们，并设置自动刷新的频率。",
      ro: "Cifrele tale importante nu mai cer deschiderea aplicației: 41 de widgeturi noi de analiză arată direct pe ecranul principal finanțele și profitul, resursele umane, flota, stocul, vânzările și lead-urile, suportul, fișele de lucru, Viva și statisticile de SMS și e-mail, pe Android și iPhone. Le alegi din Widgeturi și setezi cât de des se reîncarcă singure.",
      svn: "Za ključne številke ni več treba odpreti aplikacije: 41 novih pripomočkov s pregledom prikazuje finance in poslovni izid, kadre, vozni park, zalogo, prodajo in potencialne stranke, podporo, delovne naloge, Vivo ter statistiko SMS in e-pošte kar na začetnem zaslonu, v Androidu in iPhonu. Izberete jih v Pripomočkih in nastavite, kako pogosto se sami osvežijo.",
    },
  },
];

export default widgetsEntries;
